import React from 'react'

import CreateOrganization from '../../../components/CreateOrganization'
import ContextMenu from '../../../components/ContextMenu'

export default function () {
  return (
    <div className='container'>
      {/* <h1 className='title'>Create a new organization</h1> */}
      <ContextMenu renderTitle={() => <h1 className='title'>Create a new organization</h1>}></ContextMenu>
      <CreateOrganization />
    </div>
  )
}
